import { Card } from './Card';
import { HStack, VStack, Heading, useBreakpointValue, type BoxProps } from '@chakra-ui/react';
import { ScoreReassignmentNoticeButton } from '@/components/ScoreReassignmentNoticeButton';
import { TournamentScoringHelpButton } from '@/components/TournamentScoringHelpButton';
import { PROFILE_SECTION_BODY_SPACING, PROFILE_SECTION_HEADING_PROPS } from './profileSectionStyles';

interface ScoreCardProps extends Omit<BoxProps, 'children'> {
  currentScore: number;
  prevScore: number;
  showScoringHelp?: boolean;
  /** Desktop profile column: header aligns with My List / My Leagues. */
  compact?: boolean;
}

export function ScoreCard({
  currentScore,
  prevScore,
  showScoringHelp = false,
  compact = false,
  ...cardProps
}: ScoreCardProps) {
  const scoreDiff = currentScore - prevScore;
  const scoreSize = useBreakpointValue({ base: '2xl', xl: compact ? 'lg' : 'xl' });

  return (
    <Card
      w='full'
      h='auto'
      height='unset'
      flexShrink={0}
      borderRadius={compact ? 0 : undefined}
      {...cardProps}
    >
      <VStack spacing={PROFILE_SECTION_BODY_SPACING} align='center' w='full'>
        <HStack spacing={2} justify='center' align='center' flexWrap='wrap' w='full'>
          <Heading {...PROFILE_SECTION_HEADING_PROPS} textAlign='center'>
            My Points
          </Heading>
          <ScoreReassignmentNoticeButton />
          {showScoringHelp ? <TournamentScoringHelpButton /> : null}
        </HStack>
        <Heading
          fontSize={scoreSize}
          fontWeight='semibold'
          lineHeight='short'
          textAlign='center'
          w='full'
        >
          {currentScore} ({scoreDiff >= 0 ? '+' : null}
          {scoreDiff})
        </Heading>
      </VStack>
    </Card>
  );
}
